import { computed } from '@preact/signals-react';

import buildClient from '@furality/fox-client/buildClient.js';
import { auth } from '@furality/frontend-stack';

export const FOX_HOST =
  (import.meta.env['PUBLIC_FOX_API_HOST'] as string | undefined) ?? 'https://api.dev.fynn.ai';

const fox = computed(() =>
  buildClient({
    basePath: FOX_HOST,
    auth: {
      bearer: auth.value.auth?.token,
    },
  }),
);

export default fox;
